// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ufbY","content":"styles_content__2BqyU"};